import React from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { getDateFromAppointment } from '@lyrahealth-inc/shared-app-logic/src/features/appointments/getDateFromAppointment'
import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { LoadingSkeleton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/loadingSkeleton/LoadingSkeleton'

import { isEngageDAProvider } from '../../../../../common/utils/utils'

type ClientListSessionInfoProps = {
  nextAppointment?: Appointment | null
  lastAppointment?: Appointment | null
  providerRoles: string[]
}

const Container = styled.View({
  flexDirection: 'column',
})

const ClientListSessionDate: React.FC<ClientListSessionInfoProps> = ({
  nextAppointment,
  lastAppointment,
  providerRoles,
}) => {
  const theme = useTheme()

  if (nextAppointment === undefined || lastAppointment === undefined) {
    return <LoadingSkeleton width={120} height={48} />
  }
  if (!nextAppointment) {
    if (!lastAppointment) {
      return (
        <BodyText
          color={theme.colors.textSecondary}
          text={isEngageDAProvider(providerRoles) ? 'Schedule next session' : 'No session scheduled'}
        />
      )
    }
    const apptDate = getDateFromAppointment(lastAppointment)
    return (
      <Container>
        <BodyText
          color={theme.colors.textSecondary}
          text={isEngageDAProvider(providerRoles) ? 'Schedule next session' : 'No session scheduled'}
        />
        <BodyText
          color={theme.colors.textSecondary}
          text={
            <FormattedMessage
              defaultMessage='Last session: {sessionTime}'
              description='Last session time with client'
              values={{
                sessionTime: <FormattedDate value={apptDate} year='numeric' month='numeric' day='numeric' />,
              }}
            />
          }
        />
      </Container>
    )
  }
  const apptDate = getDateFromAppointment(nextAppointment)
  return (
    <Container>
      <BodyText text={<FormattedDate value={apptDate} weekday='short' year='numeric' month='short' day='numeric' />} />
      <BodyText text={<FormattedDate value={apptDate} hour='numeric' minute='numeric' timeZoneName='short' />} />
    </Container>
  )
}

export default ClientListSessionDate
